module.exports = __webpack_public_path__ + "static/media/vedanshi.d161bad7.jpeg";